import axios from 'axios';

export const httpClient = axios.create({
    baseURL: 'http://ec2-54-236-241-73.compute-1.amazonaws.com:64052/signs/cuotitas/requests'
});

// Interceptor para enviar datos recibidos y checar errores
httpClient.interceptors.response.use(null, error => {
    const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
    if (!expectedError) {
        // Loggear mensaje de error a un servicio como Sentry
        // Mostrar error genérico al usuario
        return Promise.reject(error);
    }
});

export const httpCreateClient = axios.create({
    url: 'http://ec2-54-236-241-73.compute-1.amazonaws.com:64052/signs/cuotitas/requests?with=person',
    method: 'POST',
    transformRequest: [function (data) {
        var form = new FormData();
        form.append('person.attributes[0].description', 'first_name');
        form.append('person.attributes[0].value', data.name);
        form.append('person.attributes[1].description', 'last_name');
        form.append('person.attributes[1]', data.lastname);
        form.append('person.attributes[1].description', 'gender');
        form.append('person.attributes[1]', data.gender);
        form.append('person.documents[0].document', data.dni);
        form.append('person.documents[0]idType', '1');
        return form;
    }],
});

// Interceptor para enviar datos recibidos y checar errores
httpCreateClient.interceptors.response.use(null, error => {
    const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
    if (!expectedError) {
    // Loggear mensaje de error a un servicio como Sentry
    // Mostrar error genérico al usuario
        return Promise.reject(error);
    }
});

/**
 * Simulate an asynchronous call
 * @param {Integer} ms time to wait in miliseconds
 * @returns void
 */
export function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export class CustomError extends Error {
    constructor (message) {
        super(JSON.stringify(message));
        this.name = this.constructor.name;
        this.response = {
            data: JSON.parse(this.message)
        };
        // this.code = code;
        // this.extra = extra;
        // Error.captureStackTrace(this, this.constructor);
    }

    from () {
        // const json = {
        //     error: this.message,
        //     code: this.code
        // };

        // if (this.extra) {
        //     json.extra = this.extra;
        // }
        // this.response.data = JSON.parse(this.message);
        return JSON.parse(this.message);
    }
}

export const mockResponse = async (time = 1000) => {
    await sleep(time);

    // Ejemplo de respuesta de error
    throw new CustomError({
        error: 'Bad request. Already exists a person for [idType: undefined, document: undefined]. . Person [id: 12120]',
        code: 400,
        extra: {
            key: 'person_already_exist',
            repeated: 'document',
            trace: 'B71C7Q;d5;2V;cJ',
            from: 'users',
            path: '/users',
            method: 'post'
        }
    });
    // Ejemplo de respuesta exitosa
    // return {
    //     code: 200,
    //     message: 'Ok',
    //     notification: {
    //         id: 1,
    //         id_notification_status: 4,
    //         sms_status: 'failure',
    //     }
    // };
};
